import { render, staticRenderFns } from "./PictureModal.vue?vue&type=template&id=1a26d5c7&"
import script from "./PictureModal.vue?vue&type=script&lang=ts&"
export * from "./PictureModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports